import { Component, type ReactNode } from "react";
import { Button, ErrorNotice } from "./index";
export class PageBoundary extends Component<
  { children: ReactNode },
  { error: boolean }
> {
  state = { error: false };
  static getDerivedStateFromError() {
    return { error: true };
  }
  render() {
    return this.state.error ? (
      <div className="page">
        <ErrorNotice error="页面未能正常显示，请刷新后重试" />
        <Button onClick={() => window.location.reload()}>刷新页面</Button>
      </div>
    ) : (
      this.props.children
    );
  }
}
